exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".roadmap {\n  object-fit: cover;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  width: 100%;\n  margin: 8% 0% 0% 0%;\n  padding: 4% 0% 10% 0%;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.roadmapImage {\n  width: 65%;\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n\n@media only screen and (max-width: 560px) {  \n  .roadmap {\n    margin: 60% 0% 60% 0%;\n    width: 100%;\n  }\n\n  .roadmapImageContainer {\n    object-fit: cover;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n  }\n\n  .roadmapImage {\n    width: 93%;\n  }\n}\n", ""]);

// exports
